import LocationOrangeIcon from 'assets/svg/location/location-orange.svg'
import Flex from 'common/components/Flex'
import Image from 'common/components/Image'
import Typography from 'common/components/Typography'
import { WEB_DESKTOP_RALALI_URL } from 'common/constants'
import theme from 'common/theme'
import { mediaflexCdn } from 'lib/cdn'
import { useTranslation } from 'react-i18next'
import { ISupplierItem } from 'services/Marketplace/models/RecommendationsModel/interface'
import styled from 'styled-components'

const Container = styled.a`
  background: #f5f3ef;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e9ecef;
`

const SupplierHeader = styled.div`
  padding: 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
`

const SupplierInfo = styled(Flex)`
  flex: 1;
`

const SupplierBody = styled.div`
  padding: 0 20px 20px 20px;
`

const SupplierProducts = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding-top: 20px;
`

const VerifiedLabel = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 4px;
`

const Chip = styled.span<{ color?: string }>`
  padding: 4px 12px;
  border-radius: 999px;
  border: 1px solid ${theme.colors.gray};
  background-color: ${theme.colors.white};
  font-size: 12px;
  font-weight: 500;
  color: ${(props) => props.color || theme.colors.grayDark};
  text-wrap: nowrap;
`

interface ISupplier {
  alias?: string
  categories?: string[]
  supplierImage?: string
  items?: ISupplierItem[]
  location?: string
  supplierName?: string
}

function SupplierCard({
  alias,
  categories,
  supplierImage,
  items,
  location,
  supplierName,
}: ISupplier): JSX.Element {
  const { t } = useTranslation('home')

  return (
    <Container href={`${WEB_DESKTOP_RALALI_URL}/${alias}`}>
      <SupplierHeader>
        <Image
          src={mediaflexCdn(`f=auto,w=160/${supplierImage}`)}
          height="70px"
          width="70px"
          borderTopLeftRadius="4px"
          borderTopRightRadius="4px"
          borderBottomLeftRadius="4px"
          borderBottomRightRadius="4px"
          objectFit="cover"
          lazy
        />
        <SupplierInfo gap="8px" flexDirection="column">
          <Typography type="bh6">{supplierName}</Typography>
          <VerifiedLabel type="rlabel">
            <LocationOrangeIcon width="16px" height="16px" />
            {location}
          </VerifiedLabel>
          <Flex gap="16px">
            <Chip color={theme.colors.greenDark}>
              {t('SELLER_CERTIFIED')}
            </Chip>
            <Chip>{categories?.join(', ')}</Chip>
          </Flex>
        </SupplierInfo>
      </SupplierHeader>
      <SupplierBody>
        {/* <StyledGrid templateColumn={2} columnGap="40px">
          <>
            <Typography type="rsmall">Overview</Typography>
            <Typography type="rsmall">Kategori Supplier</Typography>
            <Typography type="blabel" maxLine={2}>
              {storeDescription}
            </Typography>
            <Typography type="blabel">{categories}</Typography>
          </>
        </StyledGrid> */}
        <SupplierProducts>
          {items?.map((product, productIndex) => (
            <Image
              width="104px"
              height="104px"
              alt={t('SELLER_PRODUCT_IMAGE_ALT')}
              objectFit="cover"
              src={mediaflexCdn(`/f=auto,w=120/${product.imageUrl}`)}
              key={String(productIndex)}
            />
          ))}
        </SupplierProducts>
      </SupplierBody>
    </Container>
  )
}

export default SupplierCard
